import queryString from '@utils/query-string';
import bbtNative from '@bbtfe/native';

if (!bbtNative.isApp()) {
  bbtNative.userinfo = {};
  bbtNative.ready = function (callback) {
    callback && callback(bbtNative);
  };
  bbtNative.encryptApi = function (query = {}, callback) {
    query.skip = 1;
    callback &&
      callback(
        queryString
          .stringifyUrl({
            url: '',
            query
          })
          .slice(1)
      );
  };
}
